function load_doctor(id) {
    incube_ajax('collective', 'html', 'show_card', {id: id}, function (response) {
        $('body').addClass('only-screen');
        var bvi = $('.bvi-body');
        if(bvi.length)
            $('<div id="stuff-container">' + response + '</div>').appendTo(bvi);
        else
            $('<div id="stuff-container">' + response + '</div>').appendTo($('body'));
    });
}

function close_doctor() {
    $('body').removeClass('only-screen');
    $('#stuff-container').remove();
}

//Открытие карточки врача
$(document).on('click', '.stuff-link', function (e) {
    e.preventDefault();
    var id = $(this).data('id');
    if (id > 0) {
        load_doctor(id);
    }
});

//Закрытие карточки врача при клике вне блока
$(document).mouseup(function (e) {
    var div = $("#stuff-page");
    if (!div.is(e.target)
        && div.has(e.target).length === 0 && $('#stuff-container').length > 0) {
        close_doctor();
    }
});

$(document).on('click', '.navi-tabs a', function (e) {
    e.preventDefault();
    var group = $(this).data('tab-group');
    var tab = $(this).data('tab');
    var container = $(this).parents('.navi-tabs');
    $(container).find('a.active').removeClass('active');
    $(this).addClass('active');
    $('#' + group).find('.tab-info').addClass('hide');
    $('#' + tab).removeClass('hide');
});